import { AuthProvider } from "@/features/auth";
import { queryClient } from "@/infrastructure/rest";
import { RSocketProvider } from "@/infrastructure/rsocket";
import { QueryClientProvider } from "@tanstack/react-query";
import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

window.Buffer = Buffer;

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <RSocketProvider>
                    <App />
                </RSocketProvider>
            </AuthProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
